import jQuery from 'jquery';


function changeFontSize() {
    const body = document.querySelector('body');
    const $body = jQuery(body);

    const bodyStyles = window.getComputedStyle(body);
    body.dataset.initFontSize = parseInt(bodyStyles.getPropertyValue('font-size'), 10);
    const fontSize = getCookie('fontSize') || parseInt(bodyStyles.getPropertyValue('font-size'), 10);
    body.style.fontSize = `${fontSize}px`;


    const resize = (e) => {
        let incrementer = 3;

        const that = e.currentTarget;

        if (that.classList.contains('dis__font--smaller')) {
            incrementer *= -1;
        }
        const elementFontSize = parseInt(body.style.fontSize, 10);

        if (elementFontSize) {
            if ((incrementer > 0 && elementFontSize < body.dataset.initFontSize * 1.5) ||
                (incrementer < 0 && elementFontSize > body.dataset.initFontSize)) {
                body.style.fontSize = `${elementFontSize + incrementer}px`;
                setCookie('fontSize', elementFontSize + incrementer, 100);
            }
        }
    };


    $body.on('click', '.dis__font', resize);
}

function setContrast() {
    const body = document.querySelector('body');
    const $body = jQuery(body);
    if (getCookie('high_contrast') === 'true') {
        body.classList.add('high-contrast');

    }

    $body.on('click', '.dis__set-contrast', (e) => {
        e.preventDefault();
        if (getCookie('high_contrast') && getCookie('high_contrast') === 'true') {
            setCookie('high_contrast', 'false', 100); } else { setCookie('high_contrast', 'true', 100); }
        $body.toggleClass('high-contrast');
    });
}


function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

function getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export { changeFontSize, setContrast };

